<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
import {getDomainInfo} from "@/api/public"
import config from '@/utils/config'
import logoPng from '@/assets/images/logo.png'
import logoSm from '@/assets/images/logo-sm.png'
import loginLogo from '@/assets/images/login/login-logo.png'
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  created(){
    this.domainInfo()
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
    async domainInfo(){
      if(process.env.NODE_ENV=='development')return
      const params = {
        domainName: location.host
      }
      let {code,data,message } = await getDomainInfo(params)
      let siteData = {}
      if(code==200&&data!=null){
        siteData = data
        let filePath = config.fileUrl
        siteData.loginLogo = filePath+data.loginLogo[0]
        siteData.websiteHeadPhoto = filePath+data.websiteHeadPhoto[0]
        siteData.menuLogo = filePath+data.menuLogo[0]
        this.$store.commit('app/SET_SITE_DATA',siteData)
        this.updateFavicon(siteData)
      }
    },
    updateFavicon(siteData) {
      const link = document.querySelector("link[rel*='icon']");
      document.title = siteData.title
      link.rel = "icon";
      link.href = siteData.websiteHeadPhoto + "?" + new Date().getTime();
      document.getElementsByTagName("head")[0].appendChild(link);
    }
  }
}
</script>
